import { Card, Text, Group } from '@mantine/core';
import type { LucideIcon } from 'lucide-react';
import { Eyebrow } from './Eyebrow';
import { numStyle } from '../theme';

interface Props {
  icon: LucideIcon;
  label: string;
  value: React.ReactNode;
  hint?: React.ReactNode;
}

export function StatTile({ icon: Icon, label, value, hint }: Props) {
  return (
    <Card padding="sm">
      <Group gap={6} wrap="nowrap" mb={2}>
        <Icon size={12} style={{ color: 'var(--mantine-color-dimmed)', flex: '0 0 12px' }} />
        <Eyebrow>{label}</Eyebrow>
      </Group>
      <Text fw={700} fz={22} lh={1.2} style={numStyle}>{value}</Text>
      {hint && <Text fz="sm" c="dimmed">{hint}</Text>}
    </Card>
  );
}
